import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { FOR_INVESTORS_SECTIONS, FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';
import { ONE_PAGE_SHORT_SECTIONS } from 'constants/businessToolSections/onePageShort';

import { IBusinessPlanType } from 'interfaces/businessPlan';

export const getActiveFormSection = (type: IBusinessPlanType) => {
  switch (type) {
    case BUSINESS_PLAN_TYPES.ONE_PAGE:
      return ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY;
    case BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT:
      return ONE_PAGE_SHORT_SECTIONS.SHORT;
    case BUSINESS_PLAN_TYPES.FOR_INVESTORS:
      return FOR_INVESTORS_SECTIONS.OVERVIEW;
    default:
      return FOR_BANK_SECTIONS.OVERVIEW;
  }
};

export const getActiveFormSubSection = (type: IBusinessPlanType) => {
  switch (type) {
    case BUSINESS_PLAN_TYPES.FOR_INVESTORS:
      return FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_OVERVIEW.COMPANY;
    case BUSINESS_PLAN_TYPES.FOR_BANK:
      return FOR_BANK_SUB_SECTIONS.FOR_BANK_OVERVIEW.COMPANY;
    default:
      return null;
  }
};
